import { px } from '~/modules/helpers';

function Times({ size = 8 }: { size?: number }): JSX.Element {
  return (
    <svg
      height={px(size)}
      preserveAspectRatio="xMidYMid"
      version="1.1"
      viewBox="0 0 16 16"
      width={px(size)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M0.313174194,0.313176288 C0.730750479,-0.104392096 1.40776019,-0.104392096 1.82533647,0.313176288 L7.99996524,6.48786773 L14.174701,0.313176288 C14.5922452,-0.104392096 15.2692976,-0.104392096 15.6868418,0.313176288 C16.1043861,0.730755364 16.1043861,1.4077696 15.6868418,1.82534867 L9.51210613,8.00001873 L15.6867349,14.1746887 C16.1042791,14.5922357 16.1042791,15.2692928 15.6867349,15.6868398 C15.2691907,16.1043867 14.5921382,16.1043867 14.174594,15.6868398 L7.99996524,9.51216972 L1.82538994,15.6868398 C1.40782434,16.1043867 0.730814635,16.1043867 0.313238349,15.6868398 C-0.104327243,15.2692928 -0.104327243,14.5922357 0.313238349,14.1746887 L6.48782435,8.00001873 L0.313174194,1.82534867 C-0.104391398,1.4077696 -0.104391398,0.730755364 0.313174194,0.313176288 Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default Times;
